var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-data"},[_c('img',{attrs:{"src":"https://f.nanputuo.com/nanputuo/img/public/qxy_zwnr.png","alt":"暂无内容"}}),_c('p',[_vm._v("暂无内容")])])
}]

export { render, staticRenderFns }